import { get, post } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';

const url = 'api/B3';
// const options = { errorDialog: true, secure: false, baseURL: true, repeatRequestCancel: false };

export function getInfoB3() {
    return get(`${url}/info`);
}

export function submitB3(data) {
    return post(`${url}/submit`, data, { ...options, repeatRequestCancel: true });
}
